var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"dialog-close-button-position z-index-1",attrs:{"color":"#e21b23","icon":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }